export default {
  Title: 'Παραστατικά | Παραστατικό | Παραστατικά',

  Status: {
    Transmitted: {
      Id   : 1,
      Name : 'Διαβιβασμένο',
      Color: 'blue lighten-1'
    },
    Canceled: {
      Id   : 2,
      Name : 'Ακυρωμένο',
      Color: 'red'
    },
    Issued: {
      Id   : 3,
      Name : 'Εκδοθέν',
      Color: 'blue lighten-1'
    },
    Closed: {
      Id   : 4,
      Name : 'Κλειστό',
      Color: 'success'
    },
    Open: {
      Id   : 5,
      Name : 'Ανοιχτό',
      Color: 'warning'
    },
    Waiting: {
      Id   : 6,
      Name : 'Σε Αναμονή',
      Color: 'blue-grey'
    },
    Error: {
      Id   : -1,
      Name : 'Error',
      Color: 'error'
    }
  },

  Table: {
    Toolbar: {
      Button: {
        Transactions: {
          Title: 'Συναλλαγές EFT/POS',
          Icon : 'mdi-account-credit-card',
          Color: 'primary'
        },
        Export: {
          Title  : 'Εξαγωγή',
          Icon   : 'file_download',
          Color  : 'primary',
          Success: 'Σύντομα θα λάβετε αρχείο με την εξαγωγή των παραστατικών στα email που επιλέξατε'
        }
      },

      Info: {
        CompanyPackage: {
          Provider      : 'Πάροχος',
          PackageName   : 'Πακέτο',
          InitialValue  : 'Αξία',
          RemainingValue: 'Υπόλοιπο',
          ValidFrom     : 'Ενεργοποίηση',
          ValidTo       : 'Λήξη'
        }
      }
    },

    Button: {
      View: {
        Title: 'Προβολή Πελάτη',
        Icon : 'remove_red_eye',
        Color: 'cyan'
      },
      Delete: {
        Title: 'Διαγραφή Πελάτη',
        Icon : 'delete',
        Color: 'red'
      }
    },

    Headers: {
      Id      : '#',
      Type    : 'Τύπος',
      Table   : 'Τραπέζι',
      Number  : 'Αρ.Προοδ.',
      Order   : 'Παραγγελία',
      Total   : 'Πληρ. Ποσό',
      Aade    : 'ΑΑΔΕ',
      Status  : 'Κατάσταση',
      ClosedBy: 'Έκλεισε Από',
      Related : 'Σχετικά Παραστατικά',
      User    : 'Χρήστης',
      Notify  : 'Ειδοποίηση',
      Date    : 'Ημ/νία',
      Actions : ''
    },

    Filter: {
      filterFailure: {
        Type       : 'v-btn-toggle',
        Label      : 'Απώλεια Διασύνδεσης',
        PlaceHolder: 'Όλα τα παραστατικά',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: null,
            Name : 'Όλα',
            Icon : 'mdi-wifi',
            Color: 'blue darken-1',
            Class: 'white--text'
          },
          {
            Value: 'true',
            Name : 'Απώλεια',
            Icon : 'mdi-wifi-remove',
            Color: 'red darken-1',
            Class: 'white--text'
          },
          {
            Value: 'false',
            Name : 'Χωρίς',
            Icon : 'mdi-wifi-check',
            Color: 'light-green darken-1',
            Class: 'white--text'
          }
        ]
      },
      filterWithoutOpenHours: {
        Type       : 'v-btn-toggle',
        Label      : 'Βάση',
        PlaceHolder: '',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 'false',
            Name : 'Ωραρίου',
            Icon : 'mdi-store-clock',
            Color: 'green darken-1',
            Class: 'white--text'
          },
          {
            Value: 'true',
            Name : 'Ημερολογιακά',
            Icon : 'mdi-hours-24',
            Color: 'blue darken-1',
            Class: 'white--text'
          }
        ]
      },
      filterStatus: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Κατάσταση Παραστατικού',
        PlaceHolder: 'Όλα τα παραστατικά',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        Items      : []
      },
      filterInvoiceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Τύπος Παραστατικού',
        PlaceHolder: 'Όλοι οι τύποι',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        Items      : []
      },
      filterUser: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Χρήστης',
        PlaceHolder: 'Όλοι οι χρήστες',
        ItemText   : 'FullName',
        ItemValue  : 'Id',
        Items      : []
      },
      filterCompany: {
        Type       : 'v-autocomplete',
        Chips      : true,
        Multiple   : false,
        Label      : 'Πελάτες/Εταιρείες',
        PlaceHolder: 'Όλοι οι Πελάτες/Εταιρείες',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        Items      : []
      }
    }
  },

  DocumentsStatus: {
    Warning: 'Υπάρχουν ανοιχτά δελτία παραγγελίας (8.6) για περισσότερο από {minHours} ώρα και θα πρέπει να έχουν κλείσει το αργότερο έως και 24 ώρες από την έκδοσή τους.<br><br>Το σύστημα θα τα ακυρώσει αυτόματα μετά το πέρας των {maxHours} ωρών για να αποτρέψει το κλείδωμα του λογαριασμού του παρόχου. | Υπάρχουν ανοιχτά δελτία παραγγελίας (8.6) για περισσότερο από {minHours} ώρες και θα πρέπει να έχουν κλείσει το αργότερο έως και 24 ώρες από την έκδοση τους.<br><br>Το σύστημα θα τα ακυρώσει αυτόματα μετά το πέρας των {maxHours} ωρών για να αποτρέψει το κλείδωμα του λογαριασμού του παρόχου.'
  }
}
